import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { toCurrencyString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/currency.formatters';
import { TariffDimensionType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/enums/ocpi-protocol-enums';
import { PriceComponentModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/shared/price-component.model';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import * as css from '../emsp-bo-tariff-details.module.scss';

interface PriceDetailsComponentProps {
  priceComponents: PriceComponentModel[];
  currency: string;
}

export const PriceDetailsComponent = ({
  priceComponents,
  currency,
}: PriceDetailsComponentProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // TODO: Should be moved in SDK
  const energy = useMemo(
    () => priceComponents.find((p) => p.type === TariffDimensionType.ENERGY),
    [priceComponents],
  );

  // TODO: Should be moved in SDK
  const time = useMemo(
    () => priceComponents.find((p) => p.type === TariffDimensionType.TIME),
    [priceComponents],
  );

  // TODO: Should be moved in SDK
  const parking = useMemo(
    () =>
      priceComponents.find((p) => p.type === TariffDimensionType.PARKING_TIME),
    [priceComponents],
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack
      gap={GapEnum.S}
      flex={1}
      alignItems="stretch"
      className={css.priceRow}>
      {energy && (
        <Stack
          className={css.priceContainer}
          alignItems="center"
          justifyContent="center"
          flex={1}>
          <Text bold>
            {toCurrencyString(energy.price, currency)}{' '}
            <Text color={TextColor.Secondary} bold>
              / {energy.step_size} kWh
            </Text>
          </Text>
        </Stack>
      )}

      {(time || parking) && (
        <>
          {energy && (
            <Text bold className={css.plusText}>
              +
            </Text>
          )}

          <Stack
            className={css.priceContainer}
            flex={1}
            direction="column"
            gap={GapEnum.M}>
            {time && (
              <Stack flex={1} justifyContent="center">
                <Text bold>
                  {toCurrencyString(time.price, currency)}{' '}
                  <Text color={TextColor.Secondary} bold>
                    / {time.step_size} min
                  </Text>
                </Text>
              </Stack>
            )}

            {parking && (
              <Stack className={css.parkingContainer} direction="column">
                <Stack justifyContent="center">
                  <Text bold>
                    {toCurrencyString(parking.price, currency)}{' '}
                    <Text bold>/ {parking.step_size} min</Text>
                  </Text>
                </Stack>
                <Text italic>
                  {t('$.emsp-bo-tariff-details.price.parking.description')}
                </Text>
              </Stack>
            )}
          </Stack>
        </>
      )}
    </Stack>
  );
};
